import * as React from 'react';
import { useEventCallback } from '@cian/react-utils';
import { IOption, TOptionValue } from '../types';

const ANY_VALUE = 'any';

export interface IParams {
  options: IOption[];
  value?: TOptionValue;
  onChange(value?: TOptionValue): void;
  anyOption?: boolean;
}

export const useValueController = ({ anyOption = true, ...params }: IParams) => {
  const [anySelected, setAnySelected] = React.useState(!params.value);

  React.useEffect(() => {
    setAnySelected(!params.value);
  }, [params.value]);

  const options = React.useMemo(() => {
    const anyItem: IOption = {
      value: ANY_VALUE,
      label: 'Неважно',
    };

    return anyOption ? [anyItem, ...params.options] : params.options;
  }, [params.options, anyOption]);

  const value = anySelected ? ANY_VALUE : params.value;

  const onChange = useEventCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value as TOptionValue;

    params.onChange(value === ANY_VALUE ? undefined : value);
  });

  return { options, value, onChange };
};
